import { FC } from 'react'
import { Icon } from '@chakra-ui/react'

import { uniqueId } from '@/services'

export const Xlsx: FC = () => {
  const id = `clip${uniqueId()}`
  return (
    <Icon
      width="70px"
      height="70px"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3171_3639)">
        <path
          d="M43.75 2.1875V19.6875H61.25"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
        />
        <path
          d="M61.25 28.4375V19.6875L43.75 2.1875H8.75V28.4375"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M8.75 59.0625V67.8125H61.25V59.0625"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M24.7188 50.3125H21L18.5938 46.375L15.9688 50.3125H12.25L16.4062 43.9688L12.4687 37.8438H16.1875L18.375 41.7813L20.5625 37.8438H24.5L20.5625 44.1875L24.7188 50.3125Z"
          fill="white"
        />
        <path d="M26.25 50.3125V37.8438H29.5312V47.6875H34.3438V50.3125H26.25Z" fill="white" />
        <path
          d="M44.625 46.5937C44.625 47.4687 44.4063 48.125 43.9688 48.5625C43.5313 49 43.0938 49.6562 42.2188 49.875C41.3438 50.0937 40.6875 50.3125 39.5938 50.3125C38.7188 50.3125 38.0625 50.3125 37.4063 50.0937C36.75 49.875 36.3125 49.875 35.6562 49.4375V46.375C36.3125 46.8125 36.9688 47.0312 37.625 47.25C38.2813 47.4687 38.9375 47.4688 39.5938 47.4688C40.0313 47.4688 40.4688 47.4687 40.6875 47.25C40.9063 47.0312 41.125 46.8125 41.125 46.5937C41.125 46.375 41.125 46.375 40.9063 46.1562C40.6875 45.9375 40.6875 45.9375 40.4688 45.7187C40.25 45.5 39.8125 45.2812 38.7188 44.8437C37.8438 44.4062 37.1875 44.1875 36.9688 43.75C36.75 43.3125 36.3125 43.0937 36.0938 42.6562C35.875 42.2187 35.875 41.7812 35.875 41.125C35.875 40.0312 36.3125 39.1562 37.1875 38.5C38.0625 37.8437 39.1563 37.625 40.6875 37.625C42 37.625 43.3125 37.8437 44.625 38.5L43.5313 41.125C42.4375 40.6875 41.3438 40.25 40.4688 40.25C40.0313 40.25 39.8125 40.25 39.5938 40.4687C39.375 40.6875 39.375 40.9062 39.375 41.125C39.375 41.3437 39.5938 41.5625 39.8125 41.7812C40.0313 42 40.6875 42.2187 41.7813 42.875C42.875 43.3125 43.5313 43.9687 43.9688 44.4062C44.4063 44.8437 44.625 45.7187 44.625 46.5937Z"
          fill="white"
        />
        <path
          d="M57.75 50.3125H53.8125L51.4062 46.375L49 50.3125H45.2812L49.4375 43.9688L45.5 37.8438H49.2187L51.4062 41.7813L53.5937 37.8438H57.5312L53.5937 44.1875L57.75 50.3125Z"
          fill="white"
        />
        <path
          d="M67.8125 28.4375H2.1875V59.0625H67.8125V28.4375Z"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="70px" height="70px" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}
